<template>
  <button class="w-6 sm:w-7 lg:w-8" :disabled="btnDisabled" @click="completionSwitch()">
    <template v-if="isCompleted">
      <img class="animate__animated animate__bounceIn" src="@/assets/images/completed.png" alt="済"/>
    </template>
    <template v-else>
      <img class="animate__animated animate__bounceIn" src="@/assets/images/not_completed.png" alt="未済"/>
    </template>
  </button>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios } from '@/plugins/axios'
import { useStore } from '@/store/index'

export default defineComponent({
  props: {
    isCompleted: {
      type: Boolean,
      'default': () => (false),
    },
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const btnDisabled = ref(false)

    const completionSwitch = async () => {
      btnDisabled.value = true
      try {
        const response = await axios.post(`/video/completion/${route.params.video_id}`)
        store.commit('video/setVideoDetails', response.data.payload)
      } catch (error) {
        console.error(error)
      }
      btnDisabled.value = false
    }

    return {
      completionSwitch,
      btnDisabled
    }
  },
})
</script>
